module.exports = __webpack_public_path__ + "img/banner.fe32c96c.jpg";